import { CheckAnswerCard } from './CheckAnswerCard';
export default CheckAnswerCard;
